import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; 
import './MenuBar.css'; 
function MenuBar() {
  const { t } = useTranslation();
  return (
    <div>
    <div className="menu-bar">
  <ul>
    <li><Link to="/" className="menu-link">Home</Link></li>
    <li>
      <Link className="menu-link">{t('menubarurban')}</Link>
      <ul class="submenu">
        <li><Link to="/whatisit" className="submenu-link">{t('whatIsIt')}</Link></li>
<p style={{  textAlign: 'left', marginLeft: '0', color: '#FFFFFF', fontSize: '20px', fontWeight: 'bold', borderBottom: '2px solid #00D1FF', 
  paddingBottom: '0px', marginBottom: '1px', display: 'block', width: '80%'}}>{t('storesKey')}</p>
           <ul class="submenu">
           <li><Link to="/urban" className="submenu-link">{t('residues')}</Link></li>
          <li></li>
           <li><Link to="/urban" className="submenu-link">{t('agricultureFood')}</Link></li>
           <li><Link to="/urban" className="submenu-link">{t('localProductionIndustry')}</Link></li>
           <li><Link to="/urban" className="submenu-link">{t('energy')}</Link></li>
           <li><Link to="/urban" className="submenu-link">{t('mobilityTransportation')}</Link></li>
           <li><Link to="/urban" className="submenu-link">{t('waterSanitation')}</Link></li>
           <li><Link to="/urban" className="submenu-link">{t('constructionInfrastructure')}</Link></li>
           </ul>
      </ul>
    </li>

   

    <li><Link to="/tool" className="menu-link">{t('example')}</Link></li>
    <li>
    <li><Link to="/example" className="menu-link">{t('tool')}</Link></li>
      <ul class="submenu">
        <li><Link to="/example" className="submenu-link">{t('planningOrganization')}</Link></li>
        <li><Link to="/comp2" className="submenu-link">{t('sectorMonitoring')}</Link></li>
        <li><Link to="/comp3" className="submenu-link">{t('sustainabilityAssessment')}</Link></li>
      </ul>
    </li>
    <li><Link to="/publications" className="menu-link">{t('publications')}</Link></li>
  </ul>
</div>

</div>
  );
}

export default MenuBar;